// Mount the Database module: build its host from what only this app can supply and hand it to
// `createDatabaseModule`. `service-modules.ts` and `service-scopes.ts` take the routes and the
// catalog scopes from HERE, so the module cannot be mounted unregistered. The HTTP client is not a
// member: the module reads it from the shared registry (`@vnetwork/margarita-core/http`).
import { useMyServices, serviceLabel, serviceProviderScope } from '@/api/services';
import { createDatabaseModule } from '@vnetwork/margarita-database';

export const database = createDatabaseModule({ useMyServices, serviceLabel, serviceProviderScope });
